// Imports ------------------------------------------------------------------->

import {Component} from "../Component";
import {icons} from "../../icons/SpinnerIcons";
import {element} from "../CustomElement";

// Private Definitions ------------------------------------------------------->

// Public Definitions -------------------------------------------------------->

@element("flipp-loading-animation")
export class LoadingAnimation extends Component<{}, {}> {
	render() {
		return <section flex-vertical fill-absolute>
				<div class="happiest-fruit-alive bounce">
					<span class="apple">{icons.apple}</span>
					<span class="cheese">{icons.cheese}</span>
					<span class="bread">{icons.bread}</span>
					<span class="basket">{icons.basket}</span>
				</div>
			</section>;
	}

}
